export const addTooltipText = 'Add unit';
export const searchTooltipText = 'Search by approval unit name';
export const removeTooltipText = 'Delete this unit';
export const editTooltipText = 'Edit this unit';
export const informTitle = `Approval unit can't be deleted`;
export const attachedInformText = `This approval Unit can't be deleted, as it is assigned to the asset type.
	In order to delete the approval Unit please unassigned the Unit from the Asset type.`;
